import { Column, Row } from 'Components/Grid';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useAuthTenant } from 'store/auth';
import { getLegalBases } from 'services/mapping-service';
import { CustomTableReport } from '../styles';

const AreaAndProcesses = ({ dados }) => {
  const { t } = useTranslation('mapping');
  return (
    <Column className="px-0">
      <CustomTableReport>
        <thead>
          <tr>
            <th>{t('ropa.executiveSummary.areasPlural')}</th>
            <th>{t('ropa.executiveSummary.processesLabel')}</th>
          </tr>
        </thead>
        <tbody>
          {dados &&
            dados.map(item => (
              <tr key={`row-area-process-${item.areaName}`}>
                <td>{item.areaName}</td>
                <td>
                  {item.processes &&
                    item.processes.map(subitem => (
                      <>
                        {subitem}
                        <br />
                      </>
                    ))}
                </td>
              </tr>
            ))}
          {(!dados || dados?.length === 0) && (
            <tr>
              <td>{t('ropa.executiveSummary.noRecords')}</td>
            </tr>
          )}
        </tbody>
      </CustomTableReport>
    </Column>
  );
};

const ProcessesWithoutArea = ({ dados }) => {
  const { t } = useTranslation('mapping');
  return (
    <Column className="px-0">
      <CustomTableReport>
        <thead>
          <tr>
            <th>{t('ropa.executiveSummary.processesWithoutArea')}</th>
          </tr>
        </thead>
        <tbody>
          {dados &&
            dados.map(item => (
              <tr key={`row-process-without-area-${item}`}>
                <td>{item}</td>
              </tr>
            ))}
          {(!dados || dados?.length === 0) && (
            <tr>
              <td>{t('ropa.executiveSummary.noRecords')}</td>
            </tr>
          )}
        </tbody>
      </CustomTableReport>
    </Column>
  );
};

const AreasDetails = ({ dados }) => {
  const { t, i18n } = useTranslation('mapping');
  const selectedTenant = useSelector(useAuthTenant);
  const { data: legalBasesList } = useQuery(
    ['getLegalBases', selectedTenant?.slug, i18n.language],
    async () => {
      if (!selectedTenant?.slug) return [];
      const result = await getLegalBases(selectedTenant.slug);
      return result?.data?.data ?? [];
    },
  );
  const legalBaseByKey = new Map((legalBasesList ?? []).map((lb) => [lb.key, lb.name]));
  return (
    <Column className="px-0">
      <CustomTableReport>
        <thead>
          <tr>
            <th className="text-left less-p">{t('ropa.executiveSummary.businessAreaSingle')}</th>
            <th className="text-left less-p">{t('ropa.executiveSummary.systemsAssetsCol')}</th>
            <th className="text-left less-p">{t('ropa.executiveSummary.personalDataPlural')}</th>
            <th className="text-left less-p">{t('ropa.executiveSummary.sensitivePersonalDataPlural')}</th>
            <th className="text-left less-p">{t('ropa.executiveSummary.legalBasesCol')}</th>
          </tr>
        </thead>
        <tbody>
          {dados &&
            dados.map(item => (
              <tr key={`row-${item.areaName}`}>
                <td>{item.areaName}</td>
                <td>
                  {item.assetsAndSystems &&
                    item.assetsAndSystems.map(subitem => (
                      <>
                        {subitem}
                        <br />
                      </>
                    ))}
                </td>
                <td>
                  {item.dadosPessoais &&
                    item.dadosPessoais.map(subitem => (
                      <>
                        {subitem}
                        <br />
                      </>
                    ))}
                </td>
                <td>
                  {item.dadosPessoaisSensiveis &&
                    item.dadosPessoaisSensiveis.map(subitem => (
                      <>
                        {subitem}
                        <br />
                      </>
                    ))}
                </td>
                <td>
                  {item.legalBases &&
                    item.legalBases.map(subitem => (
                      <>
                        {legalBaseByKey.get(subitem) ?? subitem}
                        <br />
                      </>
                    ))}
                </td>
              </tr>
            ))}
          {(!dados || dados?.length === 0) && (
            <tr>
              <td>{t('ropa.executiveSummary.noRecords')}</td>
            </tr>
          )}
        </tbody>
      </CustomTableReport>
    </Column>
  );
};

export const GeneralView = ({ generalView }) => {
  return (
    <>
      <Row className="mt-4">
        {generalView.areaAndProcesses && <AreaAndProcesses dados={generalView.areaAndProcesses} />}
      </Row>
      <Row className="mt-4">
        {generalView.processesWithoutArea && <ProcessesWithoutArea dados={generalView.processesWithoutArea} />}
      </Row>
      <Row className="mt-4">{generalView.areasDetails && <AreasDetails dados={generalView.areasDetails} />}</Row>
    </>
  );
};
